import React, { useMemo } from 'react';
import './student-onboarding-fall-2023.css'
import SearchHeader from '../SearchHeader/SearchHeader';
import { FilterTypeId } from '../SearchHeader/filters-type';
import axios from 'axios';
import _ from "lodash";
import { baseUrl } from '../assets/Animations';
import {BsThreeDotsVertical} from 'react-icons/bs'
import { FinishedLady } from './assets/FinishedLady';
import { getRequestHeaders } from '../api';
import StudentOnboardingTaskCard2023 from './StudentOnboardingTaskCard2023/StudentOnboardingTaskCard2023';
import ConfettiZoneStudentOnboarding from './ConfettiZoneStudentOnboarding';
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023';
import ManuallyAddStudentPopup from './ManuallyAddStudentPopup/ManuallyAddStudentPopup';


const StudentOnboardingFall2023 = ({
        setStudentOnboardingModal, 
        rawStudentOnboardingCards,
        setRawStudentOnboardingCards,
        studentOnboardingCards, 
        setStudentOnboardingCards,
        isConfettiExplosion,
        setIsConfettiExplosion,
        socket,
        userData,
        studentOnboardingCardsInUse,
        setStudentOnboardingCardsInUse
    }) => {

    const [schools, setSchools] = React.useState([]);
    //const [calendarEvents, setCalendarEvents] = React.useState([]);
    const [filterState, setFilterState] = React.useState({school: 'all'});
    const [openDropdown, setOpenDropdown] = React.useState(false);
    const [manuallyAddStudentPopup, setManuallyAddStudentPopup] = React.useState(false);
    const [labels, setLabels] = React.useState({});
    const [displayWaitlist, setDisplayWaitlist] = React.useState(true);
    const [displaySummerBreakPeople, setDisplaySummerBreakPeople] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [showSchoolsOnCards, setShowSchoolsOnCards] = React.useState(true);
    const [toolTip, setToolTip] = React.useState(false);
    const [teachers, setTeachers] = React.useState([]);
    const [nameQuery, setNameQuery] = React.useState("");
    const hasLoadedBoardRef = React.useRef(false);
    const hasInitializedRef = React.useRef(false);

    const onboardingColumns = [
        {
            title: 'TEACHER LEAVING',
            filterName: 'leaving',
            dropDownMenuOptions: [
                {
                    label: displayWaitlist ? 'Hide' : 'Show',
                    onClick: () => setDisplayWaitlist(!displayWaitlist)
                },
                {
                    label: displaySummerBreakPeople ? 'Hide Summer Break Students' : 'Show Summer Break Students',
                    onClick: () => setDisplaySummerBreakPeople(!displaySummerBreakPeople)
                },
            ],
            total: true
        },
        // {
        //     title: 'WAITLIST',
        //     filterName: 'waitlist',
        //     dropDownMenuOptions: [
        //         {
        //             label: displayWaitlist ? 'Hide' : 'Show',
        //             onClick: () => setDisplayWaitlist(!displayWaitlist)
        //         },
        //     ],
        //     total: true
        // },
        // {
        //     title: 'INQUIRIES',
        //     filterName: 'inquiry',
        //     dropDownMenuOptions: [
        //         {
        //             label: '+ New Student (Default)',
        //             onClick: () => setManuallyAddStudentPopup(['New Student', 'inquiry'])
        //         },
        //         {
        //             label: '+ Reassign',
        //             onClick: () => setManuallyAddStudentPopup(['Reassign', 'inquiry'])
        //         },
        //         {
        //             label: '+ Old Student',
        //             onClick: () => setManuallyAddStudentPopup(['Old Student', 'inquiry'])
        //         }
        //     ],
        //     total: false
        // },
        {
            title: 'SCHEDULING',
            filterName: 'scheduling',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'scheduling'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'scheduling'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'scheduling'])
                }
            ],
            total: true
        },
        {
            title: 'INTRO LESSON',
            filterName: 'intro',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'intro'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'intro'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'intro'])
                }
            ],
            total: true
        },
        {
            title: 'ONBOARDING',
            filterName: 'onboarding',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'onboarding'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'onboarding'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'onboarding'])
                }
            ],
            total: true
        },
        {
            title: 'OFFBOARDING',
            filterName: 'offboard',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'offboard'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'offboard'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'offboard'])
                }
            ],
            total: true
        }
    ]

    React.useEffect(() => {
        if (hasInitializedRef.current) return
        hasInitializedRef.current = true
        makeCalls();
        userData.PermissionLevel === 'manager' && setFilterState({school: userData.School.toLowerCase()})
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                clickBackOnCalls()
            }
          };
      
          // Add the event listener to the document
          document.addEventListener('visibilitychange', handleVisibilityChange);
      
          // Clean up the event listener when the component unmounts
          return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
          };
    }, [])

    React.useEffect(() => {
        setOpenDropdown(false)
    },[displayWaitlist])

    React.useEffect(() => {
        highlightAlreadyInUseCards()
    }, [studentOnboardingCardsInUse])

    React.useEffect(() => {
        socket.on('createStudentWorkflow', (packet) => {
            if(packet.emitter !== userData.Name) {
                setRawStudentOnboardingCards(prev => [...prev, packet.data])
                setStudentOnboardingCards(prev => [...prev, packet.data])
                //setRawWaitlistFamilies(prev => prev.filter((family) => family.familyId !== packet.data.familyId && family))
            }
            if(packet.data.todoId) {
                moveCardAnimation(packet.data.todoId)
            }

        })
        socket.on('openStudentWorkflow', (packet) => {
            if(packet.emitter !== userData.Name) {
                setLabels(prev => ({...prev, [packet.data]: packet.emitter}))
            }
        })
        socket.on('closeAndSaveStudentWorkflow', (packet) => {
            if(packet.updatedCard.emitter !== userData.Name) {
                //remove the todoId key value pair from labels
                let labelsCopy = labels;
                delete labelsCopy[packet.updatedCard.data.todoId]
                setLabels({...labelsCopy})
                setRawStudentOnboardingCards(prev => prev.map(flow => flow.todoId === packet.updatedCard.data.todoId ? packet.updatedCard.data : flow))
                setStudentOnboardingCards(prev => prev.map(flow => flow.todoId === packet.updatedCard.data.todoId ? packet.updatedCard.data : flow))
                setStudentOnboardingCardsInUse(prev => prev.filter(card => card.data !== packet.updatedCard.data.todoId))
            }
            moveCardAnimation(packet.updatedCard.data.todoId)
        })
        socket.on('closeAndDeleteStudentWorkflow', async (packet) => {
            if(packet.emitter !== userData.Name) {
                let labelsCopy = labels;
                delete labelsCopy[packet.data]
                setLabels({...labelsCopy})
                setRawStudentOnboardingCards(prev => prev.filter(flow => flow.todoId !== packet.data))
                setStudentOnboardingCards(prev => prev.filter(flow => flow.todoId !== packet.data))
                //let waitListFamiliesRefresh = await getWaitlistStudents();
                //setRawWaitlistFamilies(waitListFamiliesRefresh.data)
            }
        })
    }, [socket])

    React.useEffect(() => {
        userData.PermissionLevel === 'manager' && setFilterState({school: userData.School.toLowerCase()})
        if(filterState.school === 'all' || !filterState.school) {
            setShowSchoolsOnCards(true)
        } else {
            setShowSchoolsOnCards(false)
        }
    }, [filterState, userData.PermissionLevel, userData.School])

    React.useEffect(() =>
          isConfettiExplosion &&
          setTimeout(() => {
            setIsConfettiExplosion(false);
          }, 5000)
    , [isConfettiExplosion]);

    const moveCardAnimation = (id) => {
        setTimeout(() => {
            if(!document.getElementById(id)) {return}
            document.getElementById(id).style.animation = 'cardMoveAttentionFlash 500ms'
            document.getElementById(id).style.animationTimingFunction = 'ease'
            document.getElementById(id).style.border = '1px solid orange'
            setTimeout(() => {
                document.getElementById(id).style.border = '1px solid #fff'
            }, 1000);
        }, 0)
    }

    const fetchTeachers = React.useCallback(async () => {
        try {
            const teacherResponse = await axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders())
            setTeachers(Array.isArray(teacherResponse.data) ? teacherResponse.data : [])
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchBoardData = React.useCallback(async () => {
        try {
            setLoading(true)
            const schoolParam =
                userData.PermissionLevel === 'manager'
                    ? userData.School.toLowerCase()
                    : 'all'

            const boardReturn = await axios.get(`${baseUrl}/student-onboarding-board`, {
                ...getRequestHeaders(),
                params: {
                    school: schoolParam,
                    includeSummerBreak: displaySummerBreakPeople
                }
            })

            const boardCards = Array.isArray(boardReturn?.data?.cards) ? boardReturn.data.cards : []
            const boardSchools = Array.isArray(boardReturn?.data?.schools) ? boardReturn.data.schools : []

            setRawStudentOnboardingCards(boardCards)
            setStudentOnboardingCards(boardCards)
            setSchools(boardSchools.length > 0 ? boardSchools : [
                { id: 'all', label: 'All Schools' },
                { id: 'mma', label: 'Mountainside' },
                { id: 'lsma', label: 'Lakeside' },
                { id: 'tma', label: 'Treeside' },
                { id: 'mor', label: 'Morningside' },
                { id: 'psma', label: 'Parkside' },
                { id: 'den', label: 'Denton' },
                { id: 'tem', label: 'Tempe' },
                { id: 'tul', label: 'Tulsa' }
            ])
            hasLoadedBoardRef.current = true
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }, [
        displaySummerBreakPeople,
        setRawStudentOnboardingCards,
        setStudentOnboardingCards,
        userData.PermissionLevel,
        userData.School
    ])



    const makeCalls = async () => {
        await Promise.all([fetchBoardData(), fetchTeachers()])
    };


    const clickBackOnCalls = async () => {
        await fetchBoardData()
    }

    React.useEffect(() => {
        if (!hasLoadedBoardRef.current) return
        fetchBoardData()
    }, [displaySummerBreakPeople, fetchBoardData])

    // const checkIfIntroLessonHasHappened = (card) => {
    //     if(card.hasIntroHappened) {return card}
    //     //if the card is in the onboarding column
    //     if(card.whichList === 'onboarding') {
    //     //if the card has a familyId
    //         if(card.familyId) {
    //             for(let i = 0; i < calendarEvents.length; i++) {
    //                 let event = calendarEvents[i]
    //                 if(event.familyId === card.familyId) {
    //                     if(!event.isPendingOffer) {
    //                         const dateIsWithinInterval = isWithinInterval(new Date(event.dateTime),{ start: subWeeks(new Date(), 1), end: new Date() })
    //                         if(dateIsWithinInterval && checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = false
    //                             return card
    //                         } else if (dateIsWithinInterval && !checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = 'follow-up'
    //                             return card
    //                         }
    //                     }
    //             }
    //         }
    //         }
    //         card.hasIntroHappened = false
    //         return card
    //     }
    // }

    const filteredCards = React.useMemo(() => {
        const nameFilter = nameQuery.toString().toLocaleLowerCase()
        const selectedSchools = (filterState.school === 'all' || !filterState.school) ? null : filterState.school
        const selectedInstruments = filterState.instrument

        return studentOnboardingCards.filter((card) => {
            const teachName = card.todoName.toString().toLocaleLowerCase()
            const nameMatch = !nameFilter || teachName.includes(nameFilter)

            const schoolMatch =
                !selectedSchools ||
                selectedSchools.length === 0 ||
                selectedSchools.includes(card.whichSchool)

            const instrumentMatch =
                !selectedInstruments ||
                selectedInstruments.length === 0 ||
                card.studentList.some((student) =>
                    student.instrumentList.some((instrument) =>
                        selectedInstruments.includes(instrument.id)
                    )
                )

            return nameMatch && instrumentMatch && schoolMatch
        })
    }, [filterState.instrument, filterState.school, nameQuery, studentOnboardingCards])

    const cardsByColumn = React.useMemo(() => {
        const grouped = {}
        onboardingColumns.forEach((column) => {
            grouped[column.filterName] = []
        })

        filteredCards.forEach((card) => {
            if(displayWaitlist === false && card.whichList === 'waitlist') {
                return
            }

            if (grouped[card.whichList]) {
                grouped[card.whichList].push(card)
            }

            if (
                card.whichList === 'student' &&
                (filterState.school === 'all' || !filterState.school || card.whichSchool.toLowerCase() === filterState.school)
            ) {
                grouped.scheduling = grouped.scheduling || []
                grouped.scheduling.push(card)
            }
        })

        Object.keys(grouped).forEach((list) => {
            if(list === 'intro') {
                grouped[list].sort((a, b) => new Date(a.todoDueDate) - new Date(b.todoDueDate))
            } else if (list === 'leaving') {
                grouped[list].sort((a, b) => new Date(b.leavingDate) - new Date(a.leavingDate))
            } else {
                grouped[list].sort((a, b) => new Date(b.todoDueDate) - new Date(a.todoDueDate))
            }
        })

        return grouped
    }, [displayWaitlist, filteredCards, filterState.school, onboardingColumns])

    // const formatFamilyIntoCardForWaitlist = (family) => {
    //     let card = {
    //         todoId: family.familyId,
    //         todoName: family.familyStatus === 'Waitlist' ? `${family.familyName}` : findWaitlistStudentandReturnName(family),
    //         todoDescription: '',
    //         familyId: family.familyId,
    //         studentList: family.students,
    //         todoDueDate: new Date(),
    //         todoAlarm: false,
    //         theyHaveBeenCalled: false,
    //         todoOwner: '',
    //         waitlistEntity: assessTheFamiliesWaitlistStatus(family),
    //         whoIsOnWaitlist: family.familyStatus === 'Waitlist' ? 'Family' : 'Student',
    //         whichList: 'waitlist',
    //         whichSchool: family.school.toLowerCase(),
    //         todoSubtasks: []
    //       }
    //       return card
    // }

    // const assessTheFamiliesWaitlistStatus = (family) => {
    //     let listOfWaitlistLabelAndIdPairs = [];
    //     let listOfWaitlistEntities = [];
    //     //Find if family is on waitlist and if the students are on the waitlist
    //     if(family.familyStatus === 'Waitlist') {
    //         listOfWaitlistLabelAndIdPairs.push(['Family', family.familyId])
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     } else {
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     }
    //     //get all the waitlist entities
    //     listOfWaitlistLabelAndIdPairs.forEach((pair) => {
    //         let entity = checkForWaitlistEntitiesForFamily(pair)
    //         entity && listOfWaitlistEntities.push(entity)
    //     })
    //     //find the oldest waitlist entity in the array
    //     let oldestWaitlistEntity = listOfWaitlistEntities[0];
    //     for(let i = 1; i < listOfWaitlistEntities.length; i++) {
    //         if(listOfWaitlistEntities[i].startDate < oldestWaitlistEntity.startDate) {
    //             oldestWaitlistEntity = listOfWaitlistEntities[i];
    //         }
    //     }
    //     return oldestWaitlistEntity ? oldestWaitlistEntity : null;
    // }

    const highlightAlreadyInUseCards = () => {
        for(let i = 0; i < studentOnboardingCards.length; i++) {
            if(document.getElementById(studentOnboardingCards[i].todoId)) {
                document.getElementById(studentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${studentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < rawStudentOnboardingCards.length; i++) {
            if(document.getElementById(rawStudentOnboardingCards[i].todoId)) {
                document.getElementById(rawStudentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${rawStudentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < studentOnboardingCardsInUse.length; i++) {
            if(document.getElementById(studentOnboardingCardsInUse[i].data)) {
                document.getElementById(studentOnboardingCardsInUse[i].data).style.border = "2px solid fuchsia"
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.padding = '2px'
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.display = 'inline-block'
            }
        }
    }

    const createASpecificCardForASpecificFamily = (familyId, column, typeOfCard, callback) => {
        axios.post(`${baseUrl}/create-student-onboarding-card/${familyId}/${column}/${typeOfCard}`, getRequestHeaders())
        .then(() => {
            fetchBoardData()
            callback(false)
        })
        .catch((err) => console.log(err))
    }


    const filters = useMemo(() => [
        {
            id: "instrument",
            label: "Instrument",
            type: FilterTypeId.Dropdown,
            options:
              teachers &&
              _.uniqBy(
                teachers.reduce((acc, teacher) => {
                  return [
                    ...acc,
                    ...teacher.InstrumentList.map((instrument) => {
                      return {
                        id: instrument.id,
                        label: instrument.name,
                        group: instrument.instrumentGroup,
                      };
                    }),
                  ];
                }, []),
                (x) => x.id
              ),
          },
        userData.PermissionLevel !== 'manager' && {
            id: "school",
            label: "School",
            type: FilterTypeId.SelectDropDown,
            options: schools ? schools : [],
          },
        ], [schools, teachers, userData.PermissionLevel]);

    const openStudentOnboardingCard = (card) => {
        socket.emit('openStudentWorkflow', {emitter: userData.Name, data:card.todoId})
        setStudentOnboardingModal(card)
    }

    const isReassignmentCard = (card) => {
        return card?.todoDescription === 'Reassign' || card?.whichList === 'orange'
    }

    const isOldStudentCard = (card) => {
        return card?.todoDescription === 'Old Student' || card?.whichList === 'blue'
    }

    const calculateTotals = (list) => {
        let totalStudents = 0;
        let newStudents = 0;
        ;(cardsByColumn[list] || []).forEach((card) => {
            if(card.whichList === list) {
                totalStudents = totalStudents + card.studentList.length

                if(!isOldStudentCard(card) && !isReassignmentCard(card)) {
                    newStudents = newStudents + card.studentList.length
                }
            }
        })

        if(totalStudents === 0 && newStudents === 0) {
            return null
        }

        return `(${totalStudents}) (${newStudents} new)`
    }

    return (
        <div className='student-onboarding-fall-2023__wrapper'>
            {manuallyAddStudentPopup && <ManuallyAddStudentPopup manuallyAddStudentPopup={manuallyAddStudentPopup} setManuallyAddStudentPopup={setManuallyAddStudentPopup} createASpecificCardForASpecificFamily={createASpecificCardForASpecificFamily} />}
            {/* {toolTip && <OnboardingToolTip2023 card={toolTip} calendarEvents={calendarEvents} />} */}
            <ConfettiZoneStudentOnboarding isConfettiExplosion={isConfettiExplosion} />
            <SearchHeader title= "Student Onboarding" filters={filters} onChangeQuery={(string) => setNameQuery(string)} onChangeFilters={(filterState) => setFilterState(filterState)} clearAll={true} />
            <div className='student-onboarding-fall-2023__columns-wrapper'>
                {onboardingColumns.map((column, index) => {
                    const columnCards = cardsByColumn[column.filterName] || []
                    return <div key={index} className='student-onboarding-fall-2023__column'>
                        <div className='student-onboarding-fall-2023__column-title__area'>
                            <div className='student-onboarding-fall-2023__column-title'>{column.title} {column.total ? calculateTotals(column.filterName) : null}</div>
                            <BsThreeDotsVertical cursor={'pointer'} color='#94A3B8' onClick={() => setOpenDropdown(column.title)} />
                            {openDropdown === column.title && <ModalDropdownMenuFall2023 menuItems={column.dropDownMenuOptions} setOpenDropdown={setOpenDropdown} />}
                        </div>
                        {
                            loading && columnCards.length === 0 ? 
                            <div className='student-onboarding-fall-2023__loading'>LOADING...</div>  
                        :
                            <div className='student-onboarding-fall-2023__column-scroll-area' style={columnCards.length === 0 ? {backgroundColor: '#F1F5F9'} : {backgroundColor: 'rgb(248, 250, 252)'}}>
                            {columnCards.length > 0 ?
                                <div>
                                    {columnCards.map((card) => <StudentOnboardingTaskCard2023 key={card.todoId} labels={labels} card={card} showSchoolsOnCards={showSchoolsOnCards} setStudentOnboardingModal={openStudentOnboardingCard} setToolTip={setToolTip} />)}
                                </div>
                                :
                                <div className='finished-lady__wrapper'>
                                    <FinishedLady />
                                </div>
                                }
                        </div>
                    }
                    </div>
                })}
            </div>
        </div>
    )
}
export default StudentOnboardingFall2023;
